import { render, staticRenderFns } from "./IndividualAccount.vue?vue&type=template&id=37708a7c&scoped=true"
import script from "./IndividualAccount.vue?vue&type=script&lang=js"
export * from "./IndividualAccount.vue?vue&type=script&lang=js"
import style0 from "./IndividualAccount.vue?vue&type=style&index=0&id=37708a7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37708a7c",
  null
  
)

export default component.exports